import React, { useState , useEffect} from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { cancelOrder, getOpsCancelReasons } from '../UploadRxComponents/Services.js';




function CancelOrderModal({ orderId, onClose }) {
  const [formData, setFormData] = useState({
    orderId: orderId,
    selectedCancelReasonId : ''
  });
  const [cancelReasons, setCancelReasons] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [errMessage, setErrorMessage] = useState('');
  useEffect(() => {
    const fetchCancelReasons = async () => {
      try {
        const cancelReasons = await getOpsCancelReasons();
        console.log(cancelReasons, "fdbn")
        if(cancelReasons) {
            setCancelReasons(cancelReasons);
        }
      } catch (error) {
        console.error("Error fetching refund reasons:", error);
      }
    };

    fetchCancelReasons();
  }, []);
 



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableSubmitButton(true);

    const cancelReasonCode = cancelReasons.find((reason) => reason.id == formData.selectedCancelReasonId)
    const result = await cancelOrder(orderId, cancelReasonCode.reason_code);
    if(result.success){
        setSuccessMessage(result.message);
    }else{
        setErrorMessage(result.message);
    }
    setDisableSubmitButton(false);
  };



  return (
    <Modal isOpen={true} style={{ maxWidth: '600px', width: '100%', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
      <ModalHeader style={{ backgroundColor: '#8752CC' }} toggle={()=> onClose('close-popup')}>
        <h5 className="text-center" style={{ color: '#fff', fontWeight: 'bold' }}>Cancel Order</h5>
      </ModalHeader>
      <ModalBody style={{ paddingTop: '20px', paddingBottom: '20px', paddingLeft: '40px', paddingRight: '40px' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="orderId">Order ID:</label>
            <input type="number"  name="orderId" className="form-control" value={orderId}  readOnly  />
          </div>


          <div className="form-group">
            <label htmlFor="cancelReasons">Select Cancel Reason:</label>
                {cancelReasons && 
                    <select
                        id="cancelReasons"
                        name="selectedCancelReasonId"
                        className="form-control"
                        value={formData.selectedCancelReasonId}
                        onChange={handleChange}
                        required
                        >
                        <option value="" disabled>Cancel Reasons</option>
                        {cancelReasons.map((reason, index) => (
                            <option key={index} value={reason.id}>
                            {reason.reason_description}
                            </option>
                        ))}
                    </select>
                }
          </div>
            {errMessage && !successMessage && (
                <div className="text-center" style={{ color: '#ff4d4f',  backgroundColor: '#fff2f0',  border: '1px solid #ffccc7', marginBottom : '10px'}}>
                    {errMessage}
                </div>
            )}
            {successMessage && !errMessage && (
                <div className="text-center" style={{ color: '#389e0d',  backgroundColor: '#f6ffed',  border: '1px solid #b7eb8f',  marginBottom : '10px'}}>
                    {successMessage}
                </div>
            )}
          <div className="text-center">
            <button disabled={disableSubmitButton || !(formData.selectedCancelReasonId && !successMessage && !errMessage) } type="submit" className="btn btn-primary">Cancel Order</button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  user: state.user,
});

export default connect(mapStateToProps)(CancelOrderModal);
